import { MakeCall } from './createMakeCall';
import { FavoriteListing } from './types/FavoriteListing';

export type AddFavoriteListingCall = (
  listingId: number,
) => Promise<{ data: FavoriteListing }>;

const addFavoriteListing = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('POST', `/api/v2/listing/${listingId}/favorite`);
export { addFavoriteListing };
